import { useState, useEffect } from 'react';
import Header from './include/header';
import Footer from './include/footer';
import LeftPanel from './include/UserLeftPanel';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Global from '../APIConfig';
import axios from "axios";
import AuthUser from "../AuthUser";
import TopCustChart from './Charts/TopCustChart';
import TopHubChart from './Charts/TopHubChart';
import TopAgentChart from './Charts/TopAgentChart';
import TopStaffChart from './Charts/TopStaffChart';
import TopDriverChart from './Charts/TopDriverChart';

function CustomerDashBoard() {
    let navigate = useNavigate();
    const { headers1, logout } = AuthUser();
    const [totalcustomer, setTotalcustomer] = useState('');
    const [totalHub, setTotalHub] = useState('');
    const [totalAgent, setTotalAgent] = useState('');
    const [totalStaff, setTotalStaff] = useState('');
    const [totalDriver, setTotalDriver] = useState('');

    useEffect(() => {
        Get30DaysCustomers();
        Get30DaysHub();
        Get30DaysAgent();
        Get30DaysStaff();
        Get30DaysDriver();
    }, []);
    const Get30DaysCustomers = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Get30DaysCustomers',
            headers: headers1,
            data: {
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data;
                    setTotalcustomer(data.label);

                }
                else {
                    setTotalcustomer(0);

                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
    }
    const Get30DaysHub = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Get30DaysHub',
            headers: headers1,
            data: {
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data;
                    setTotalHub(data.label);

                }
                else {
                    setTotalHub(0);

                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
    }
    const Get30DaysAgent = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Get30DaysAgent',
            headers: headers1,
            data: {
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data;
                    setTotalAgent(data.label);
                }
                else {
                    setTotalAgent(0);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });

    }
    const Get30DaysStaff = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Get30DaysStaff',
            headers: headers1,
            data: {
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data;
                    setTotalStaff(data.label);
                }
                else {
                    setTotalStaff(0);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
    }
    const Get30DaysDriver = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Get30DaysDriver',
            headers: headers1,
            data: {
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data;
                    setTotalDriver(data.label);
                }
                else {
                    setTotalDriver(0);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
    }

    return (
        <>
            <LeftPanel />
            <main className='home-section'>
                <Header />
                <div className="overlay"></div>
                <div className='col-12 mt-4'><h2>Customer Dashboard</h2></div>

                <div className="row dash_state_box">
                    <div className="col-12 col-sm-6 col-xl-4 mb-4">
                        <div className="card border-0 shadow">
                            <div className="card-body">
                                <div className="row d-block d-xl-flex align-items-center">
                                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                        <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                            <i className="bx bx-collection"></i>
                                        </div>
                                        <div className="d-sm-none">
                                            <h2 className="fw-extrabold h5"> Customer</h2>
                                            <h3 className="mb-1">{totalcustomer}</h3>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-7 px-xl-0">
                                        <div className="d-none d-sm-block">
                                            <h2 className=""> Customer</h2>
                                            <h3 className="">{totalcustomer}</h3>
                                        </div>
                                        <small className="">
                                            Last 30 days
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-xl-4 mb-4">
                        <div className="card border-0 shadow">
                            <div className="card-body">
                                <div className="row d-block d-xl-flex align-items-center">
                                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                        <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                            <i className="bx bx-user"></i>
                                        </div>
                                        <div className="d-sm-none">
                                            <h2 className="fw-extrabold h5"> Hub</h2>
                                            <h3 className="mb-1">{totalHub}</h3>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-7 px-xl-0">
                                        <div className="d-none d-sm-block">
                                            <h2 className=""> Hub</h2>
                                            <h3 className="">{totalHub}</h3>
                                        </div>
                                        <small className="">
                                            Last 30 days
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-xl-4 mb-4">
                        <div className="card border-0 shadow">
                            <div className="card-body">
                                <div className="row d-block d-xl-flex align-items-center">
                                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                        <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                            <i className="bx bx-user-pin"></i>
                                        </div>
                                        <div className="d-sm-none">
                                            <h2 className="fw-extrabold h5"> Agent</h2>
                                            <h3 className="mb-1">{totalAgent}</h3>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-7 px-xl-0">
                                        <div className="d-none d-sm-block">
                                            <h2 className=""> Agent</h2>
                                            <h3 className="">{totalAgent}</h3>
                                        </div>
                                        <small className="">
                                            Last 30 days
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-xl-6 mb-4">
                        <div className="card border-0 shadow">
                            <div className="card-body">
                                <div className="row d-block d-xl-flex align-items-center">
                                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                        <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                            <i className="bx bx-group"></i>
                                        </div>
                                        <div className="d-sm-none">
                                            <h2 className="fw-extrabold h5"> Satff</h2>
                                            <h3 className="mb-1">{totalStaff}</h3>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-7 px-xl-0">
                                        <div className="d-none d-sm-block">
                                            <h2 className=""> Satff</h2>
                                            <h3 className="">{totalStaff}</h3>
                                        </div>
                                        <small className="">
                                            Last 30 days
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-xl-6 mb-4">
                        <div className="card border-0 shadow">
                            <div className="card-body">
                                <div className="row d-block d-xl-flex align-items-center">
                                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                        <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                            <i className="bx bx-cycling"></i>
                                        </div>
                                        <div className="d-sm-none">
                                            <h2 className="fw-extrabold h5"> Driver</h2>
                                            <h3 className="mb-1">{totalDriver}</h3>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-7 px-xl-0">
                                        <div className="d-none d-sm-block">
                                            <h2 className=""> Driver</h2>
                                            <h3 className="">{totalDriver}</h3>
                                        </div>
                                        <small className="">
                                            Last 30 days
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12 col-md-8'>
                            <section className="mb-3">
                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                                <h5>Top Customer</h5>
                                                <small>Top 5 customers by shipment booking in last 30 days</small>
                                                <TopCustChart />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                                <h5>Top Agent</h5>
                                                <small>Top 5 Agent by shipment booking in last 30 days</small>
                                                <TopAgentChart />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                                <h5>Top HUB</h5>
                                                <small>Top 5 HUB by shipment booking in last 30 days</small>
                                                <TopHubChart />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="shipment_card_st shadow-sm">
                                            <div className="card-body">
                                                <h5>Top Staff</h5>
                                                <small>Top 5 Staff by shipment booking in last 30 days</small>
                                                <TopStaffChart />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="sales_card_st shadow-sm">
                                            <div className="card-body">
                                                <h5>Top Driver</h5>
                                                <small>Top 5 Driver in last 30 days</small>
                                                <TopDriverChart />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className='col-12 col-md-4'>
                            <div className='row'>
                                <div className="list-group">
                                    <a href="#"  className="list-group-item list-group-item-action active">
                                        Customers Management
                                    </a>
                                    <a href="/CustomerAdd" className="list-group-item list-group-item-action">Add Customer</a>
                                    <a href="/CustomerList/All" className="list-group-item list-group-item-action">All Customers</a>
                                    <a href="/CustomerList/C" className="list-group-item list-group-item-action">Credit Customers</a>
                                    <a href="/CustomerList/CN" className="list-group-item list-group-item-action">Non Credit Customers</a>
                                    <a href="/CustomerList/U" className="list-group-item list-group-item-action">Contract Customers</a>
                                </div>
                                <div className="list-group mt-4">
                                    <a href="#"  className="list-group-item list-group-item-action active">
                                        HUB Management
                                    </a>
                                    <a href="/HubAdd" className="list-group-item list-group-item-action">Add Hub</a>
                                    <a href="/HubList" className="list-group-item list-group-item-action">All Hubs</a>
                                </div>
                                <div className="list-group mt-4">
                                    <a href="#"  className="list-group-item list-group-item-action active">
                                        Agent Management
                                    </a>
                                    <a href="/AgentList/AgentAdd" className="list-group-item list-group-item-action">Add Agents</a>
                                    <a href="/AgentList/All" className="list-group-item list-group-item-action">All Agents</a>
                                    <a href="/AgentList/C" className="list-group-item list-group-item-action">Credit Agents</a>
                                    <a href="/AgentList/NC" className="list-group-item list-group-item-action">Non Credit Agents</a>
                                    <a href="/AgentList/U" className="list-group-item list-group-item-action">Contract Agents</a>
                                </div>
                                <div className="list-group mt-4">
                                    <a href="#"  className="list-group-item list-group-item-action active">
                                        Staff Management
                                    </a>
                                    <a href="/StaffAdd" className="list-group-item list-group-item-action">Add Staff</a>
                                    <a href="/StaffList" className="list-group-item list-group-item-action">All Staff</a>
                                    <a href="/Privillages" className="list-group-item list-group-item-action">Staff Privillages</a>
                                </div>
                                <div className="list-group mt-4">
                                    <a href="#"  className="list-group-item list-group-item-action active">
                                        Driver Management
                                    </a>
                                    <a href="/DriverAdd" className="list-group-item list-group-item-action">Add Driver</a>
                                    <a href="/DriverList" className="list-group-item list-group-item-action">All Drivers</a>
                                </div>
                                <div className="list-group mt-4">
                                    <a href="#"  className="list-group-item list-group-item-action active">
                                        KYC Management
                                    </a>
                                    <a href="/KYCList" className="list-group-item list-group-item-action">All KYC List</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </main>
        </>
    );
}

export default CustomerDashBoard;